import axios from 'axios'

const base_url = `${process.env.VUE_APP_API_PATH}`;

export default {
    addCity(city_name) {
        const url = `${base_url}/cities`;

        return axios.post(url, city_name.toUpperCase())
    },


}
